import { MaterialCategory, MaterialType, ManufacturingMethod } from "./enums";

export class Material {

    constructor(
        public id: string,
        public name: string = "",
        public density: number = 0,
        public youngModulus: number = 0,
        public poissonsRatio: number = 0,
        public yieldStress: number = 0,
        public thermalExpansion: number = 0,
        public thermalConductivity: number = 0,
        public referenceTemperature: number = 0,
        public category: MaterialCategory = MaterialCategory.Metal,
        public type: MaterialType = MaterialType.Aluminum,
        public manufacturingMethod: ManufacturingMethod = ManufacturingMethod.AdditiveManufacturing,
        public pricePerKg: number = 0
    ) {

    }

    static fromJSON(data: any) {
        const material = new Material(
            data.id,
            data.name,
            data.density,
            data.youngModulus,
            data.poissonsRatio,
            data.yieldStress,
            data.thermalExpansion,
            data.thermalConductivity,
            data.referenceTemperature,
            data.category,
            data.type,
            data.manufacturingMethod
        );
        material.pricePerKg = data.pricePerKg ?? 0;
        return material;
    }

    toJSON() {
        return {
            id: this.id,
            name: this.name,
            density: this.density,
            youngModulus: this.youngModulus,
            poissonsRatio: this.poissonsRatio,
            yieldStress: this.yieldStress,
            thermalExpansion: this.thermalExpansion,
            thermalConductivity: this.thermalConductivity,
            referenceTemperature: this.referenceTemperature,
            category: this.category,
            type: this.type,
            manufacturingMethod: this.manufacturingMethod,
            pricePerKg: this.pricePerKg
        };
    }

}

export const Materials = [
    {
        "id": "0",
        "name": "Aluminum Scalmalloy",
        "density": 2689,
        "youngModulus": 70000,
        "poissonsRatio": 0.33,
        "yieldStress": 470,
        "thermalExpansion": 0.0000242,
        "thermalConductivity": 110,
        "referenceTemperature": 293,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Aluminum,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "1",
        "name": "Aluminum AlSi10Mg",
        "density": 2670,
        "youngModulus": 70000,
        "poissonsRatio": 0.33,
        "yieldStress": 230,
        "thermalExpansion": 0.000025,
        "thermalConductivity": 160,
        "referenceTemperature": 293,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Aluminum,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "2",
        "name": "Titanium TiAl6V4",
        "density": 4420,
        "youngModulus": 114000,
        "poissonsRatio": 0.34,
        "yieldStress": 1010,
        "thermalExpansion": 0.0000086,
        "thermalConductivity": 7.3,
        "referenceTemperature": 293,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Titanium,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "3",
        "name": "Maraging Steel MS1 1.2709",
        "density": 8000,
        "youngModulus": 140000,
        "poissonsRatio": 0.3,
        "yieldStress": 1110,
        "thermalExpansion": 0.0000107,
        "thermalConductivity": 15,
        "referenceTemperature": 293,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Steel,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "4",
        "name": "StainlessSteel PH1",
        "density": 7800,
        "youngModulus": 140000,
        "poissonsRatio": 0.3,
        "yieldStress": 950,
        "thermalExpansion": 0.000011,
        "thermalConductivity": 13.8,
        "referenceTemperature": 293,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Steel,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "5",
        "name": "Stainless steel 1.4404",
        "density": 8000,
        "youngModulus": 140000,
        "poissonsRatio": 0.3,
        "yieldStress": 930,
        "thermalExpansion": 0.0000159,
        "thermalConductivity": 16.3,
        "referenceTemperature": 293,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Steel,
        "manufacturingMethod": ManufacturingMethod.Milling
    },
    {
        "id": "6",
        "name": "Stainless steel 1.4540",
        "density": 7700,
        "youngModulus": 140000,
        "poissonsRatio": 0.3,
        "yieldStress": 1300,
        "thermalExpansion": 0.0000109,
        "thermalConductivity": 19.5,
        "referenceTemperature": 260,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Steel,
        "manufacturingMethod": ManufacturingMethod.Milling
    },
    {
        "id": "7",
        "name": "Stainless steel 1.4542",
        "density": 7800,
        "youngModulus": 180000,
        "poissonsRatio": 0.3,
        "yieldStress": 595,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Steel,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "8",
        "name": "Nickel alloy IN625",
        "density": 8400,
        "youngModulus": 160000,
        "poissonsRatio": 0.31,
        "yieldStress": 650,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Nickel,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "16",
        "name": "17-4PH stainless steel (Desktop Metal)",
        "density": 7800,
        "youngModulus": 195000,
        "poissonsRatio": 0.3,
        "yieldStress": 660,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Steel,
        "manufacturingMethod": ManufacturingMethod.Milling
    },
    {
        "id": "17",
        "name": "Stainless Steel - Grade 316 (UNS S31600)",
        "density": 8000,
        "youngModulus": 200000,
        "poissonsRatio": 0.27,
        "yieldStress": 550,
        "thermalExpansion": 0.00001591,
        "thermalConductivity": 16.3,
        "referenceTemperature": 293,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Steel,
        "manufacturingMethod": ManufacturingMethod.Milling
    },
    {
        "id": "E660z6nYVE1SRXl5f8KiAAfbqsgKivncSh37ypY1Fkp",
        "name": "Aluminum Al 6061 – T6",
        "density": 2670,
        "poissonsRatio": 0.33,
        "yieldStress": 275.6,
        "youngModulus": 70000,
        "thermalExpansion": 0.000021,
        "thermalConductivity": 160,
        "referenceTemperature": 293,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Aluminum,
        "manufacturingMethod": ManufacturingMethod.Milling
    },
    {
        "id": "1X6FB1eKUTMHGpjoFOu8xohaQEEmbzQrsEEBBK0c22B",
        "name": "xSPEED - Nexa3D",
        "density": 1100,
        "poissonsRatio": 0.2,
        "yieldStress": 54,
        "youngModulus": 1590,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "7YCwDfkOQZHL6k46bQVTrYLcmq71BangA3K3ic2hYjE",
        "name": "xPERFORM - Nexa3D",
        "density": 1040,
        "poissonsRatio": 0.2,
        "yieldStress": 60,
        "youngModulus": 2460,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "xQ0WcSSMy8IYCFexJ1Q5Oe7YCDEvlgo6rvRkXTw13av",
        "name": "xPERFORM PRO - Nexa3D",
        "density": 1040,
        "poissonsRatio": 0.2,
        "yieldStress": 63,
        "youngModulus": 2460,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "3I5yPOwZeyYQjLgz3jBL9uSuXB9xEZLx7hm7qRuboB0",
        "name": "Alumide | PA12-MED(Al) - EOS",
        "density": 1360,
        "poissonsRatio": 0.2,
        "yieldStress": 48,
        "youngModulus": 3800,
        "category": MaterialCategory.Composite,
        "type": MaterialType.Composite,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "5yIrtec3BJjZ7TaHz5cEi3UWjlkMOXkQSa1CGBqYNOB",
        "name": "EOS PEEK HP3",
        "density": 1320,
        "poissonsRatio": 0.2,
        "yieldStress": 90,
        "youngModulus": 4250,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "gRTFlCWTXDGtbesk0aqWbIGE5tiFWN3biEDEqHRLkDD",
        "name": "PA 1101 | PA11 - EOS",
        "density": 1100,
        "poissonsRatio": 0.2,
        "yieldStress": 48,
        "youngModulus": 1600,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "HM1Bm03Pv8JRYfy5Ld6h5nQYkMFgL1serJnytn3H3O3",
        "name": "PA 2105 | PA12 - EOS",
        "density": 1010,
        "poissonsRatio": 0.2,
        "yieldStress": 54,
        "youngModulus": 1850,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "5beXpoQltPq3Kc9ZYXTOvSLZ78uMImSDFv34W5hQeyF",
        "name": "PA 2200 Balance 1.0 | PA12 - EOS",
        "density": 1010,
        "poissonsRatio": 0.2,
        "yieldStress": 48,
        "youngModulus": 1650,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "03f1BY2ezATZRK93qytESrQ7Oum2WzZfPZN6KcEiS0k",
        "name": "PA 2200 Performance 1.0 | PA12 - EOS",
        "density": 1010,
        "poissonsRatio": 0.2,
        "yieldStress": 50,
        "youngModulus": 1700,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "oa38ygyDMFNrJ5LhN1nUTc8NINeIBIvUAdVxgKa7Q2O",
        "name": "PA 2200 Speed 1.0 | PA12 - EOS",
        "density": 1010,
        "poissonsRatio": 0.2,
        "yieldStress": 48,
        "youngModulus": 1600,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "HqjUdgfXDXTTSKeXU4r0TKtPSSfOMLnxhUETpPKiuAC",
        "name": "PA 2200 Top Quality 1.0 | PA12 - EOS",
        "density": 1010,
        "poissonsRatio": 0.2,
        "yieldStress": 52,
        "youngModulus": 1800,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "aWKdPMphhVeh4R4CqfED3ZRziaNmCM6Y1JMFH7feHPd",
        "name": "PA 2200 Top Speed 1.0 | PA12 - EOS",
        "density": 1010,
        "poissonsRatio": 0.2,
        "yieldStress": 45,
        "youngModulus": 1500,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "IFOYiW3e2hBkeZMvhaQqNgk6znbB5ugpV4YcGHx7Bm3",
        "name": "HP 3D High Reusability PA 11 ",
        "density": 1050,
        "poissonsRatio": 0.2,
        "yieldStress": 52,
        "youngModulus": 1800,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "O2aZMDDw6S4YaYlavHTgD1W5l5RMMTO7NBQRM4onZOu",
        "name": "HP 3D High Reusability PA 12",
        "density": 1010,
        "poissonsRatio": 0.2,
        "yieldStress": 48,
        "youngModulus": 1800,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "fV7t14vpobBEcXciPXY4Po5etLidqPaq1r01QwWY231",
        "name": "HP 3D High Reusability PA 12 Glass Beads",
        "density": 1300,
        "poissonsRatio": 0.2,
        "yieldStress": 30,
        "youngModulus": 2500,
        "category": MaterialCategory.Composite,
        "type": MaterialType.Composite,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "x0NWBsOC6eeVPGSZoqEMRurZzlL9AszgzHomICEOMqM",
        "name": "VESTOSINT® 3D Z2773",
        "density": 460,
        "poissonsRatio": 0.2,
        "yieldStress": 48,
        "youngModulus": 1700,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "CYUt4k1cnWIjpnAHgg34kd4n8OBYlphH4djmct3JRxp",
        "name": "PA 3200 GF - EOS",
        "density": 1220,
        "poissonsRatio": 0.2,
        "yieldStress": 51,
        "youngModulus": 3200,
        "category": MaterialCategory.Composite,
        "type": MaterialType.Composite,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "c7hmlsgfOduUpvOYROgJjHYqRfKxe3FsfP4nAJkyJOq",
        "name": "EOS Cu - M90",
        "density": 8900,
        "poissonsRatio": 0.35,
        "yieldStress": 140,
        "youngModulus": 120000,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Copper,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "SeVAxI3ohQe2ENpmSEOdNeQAiwG6HdrIrpk8oZKM2hc",
        "name": "Steel - ST52",
        "density": 7850,
        "poissonsRatio": 0.3,
        "yieldStress": 355,
        "youngModulus": 205000,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Steel,
        "manufacturingMethod": ManufacturingMethod.Milling
    },
    {
        "id": "lcwfFHKgRn9cvuEBAhOtCUHKVTSNuWIptidw7X8xiBt",
        "name": "DSM - Arnite® T AM1210",
        "density": 1300,
        "poissonsRatio": 0.35,
        "yieldStress": 30,
        "youngModulus": 2600,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "PcCcosUUgoXYYu8XrYICL2lmtildcjf73AjVhdnKZpR",
        "name": "Somos® NeXt - DSM",
        "density": 1170,
        "poissonsRatio": 0.43,
        "yieldStress": 42.2,
        "youngModulus": 2430,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "jbK9OvyvExXpBdClGCu0VRmD37gdoJMm0eZ0FkAwK4W",
        "name": "Somos® PerFORM Reflect - DSM",
        "density": 1610,
        "poissonsRatio": 0.318,
        "yieldStress": 63,
        "youngModulus": 10135,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Composite,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "3LEWq0Z9w776I7ac8KPkoUaJEBHPKrxbKzRTH9EgEii",
        "name": "Somos® Taurus - DSM",
        "density": 1130,
        "poissonsRatio": 0.45,
        "yieldStress": 46.9,
        "youngModulus": 2310,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "ICCX8ta4Q0y4PnOPiVSnUbXkePoOVqxkhvbfEzztFPf",
        "name": "Somos® WaterShed XC 11122 - DSM",
        "density": 1120,
        "poissonsRatio": 0.4,
        "yieldStress": 48,
        "youngModulus": 2770,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "4EV2CGxh7IpsRyX7EtA6vUTPRBPlRW6WPxFsmxc6wvU",
        "name": "Arnite® T AM1210 (P) - DSM",
        "density": 1300,
        "poissonsRatio": 0.38,
        "yieldStress": 47,
        "youngModulus": 2600,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "g9EYoqeZyv6jvtHVDGbeFG7PQrRYwHjjrREODkBwewO",
        "name": "Aluminum AlSi7Mg0.6",
        "density": 2680,
        "poissonsRatio": 0.31,
        "yieldStress": 230,
        "youngModulus": 71000,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Aluminum,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "Hx6WXaQEk9OXV931b0yeV2XrSqlAObU3KYZUk09CvgC",
        "name": "Alumide | PA12-MED(Al) - EOS",
        "density": 1360,
        "poissonsRatio": 0.2,
        "yieldStress": 48,
        "youngModulus": 3800,
        "category": MaterialCategory.Composite,
        "type": MaterialType.Composite,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "K4xOQb1svzI0pDUBQdGBfM8WcQHGVqJzC3bzUwATwwe",
        "name": "Inconel 625",
        "density": 8440,
        "poissonsRatio": 0.3,
        "yieldStress": 625,
        "youngModulus": 180000,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Nickel,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "STQg65v14VsM2FT2gf4HhlY4RsEG5LbyOhDIotArzue",
        "name": "316 Binder Jet",
        "density": 8000,
        "poissonsRatio": 0.3,
        "yieldStress": 150,
        "youngModulus": 200000,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Steel,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "G6wI2295Nq50ApyOuI1f1HRRF6mxbbNkZkrYW5TheiJ",
        "name": "Steel - STRENX100",
        "density": 7850,
        "poissonsRatio": 0.3,
        "yieldStress": 690,
        "youngModulus": 205000,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Steel,
        "manufacturingMethod": ManufacturingMethod.Milling
    },
    {
        "id": "HCZwluYj9lUpoUfkpqjAU2xBJucXFhC5YPS4eLvW85g",
        "name": "Novamid ID1030",
        "density": 1120,
        "poissonsRatio": 0.3,
        "yieldStress": 33,
        "youngModulus": 2200,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "mGBi9Bl8Bh9auIK5BDpw0jR5lnTsW7EEkVbBd55pDYV",
        "name": "Novamid ID1030",
        "density": 1120,
        "poissonsRatio": 0.3,
        "yieldStress": 33,
        "youngModulus": 2200,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "ZL6zSwF8chpXLPz2GWfVj7OqeodsHjKw8URi0dQz0LL",
        "name": "Aluminium Cast A356 T6",
        "density": 2670,
        "poissonsRatio": 0.33,
        "yieldStress": 165,
        "youngModulus": 72400,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Aluminum,
        "manufacturingMethod": ManufacturingMethod.Milling
    },
    {
        "id": "JF18Rjb8nR7zm4q2gCO2eZTrF3OEISHnXfqyUHuhFj1",
        "name": "LUVOCOM 3F PEEK 9581 NT",
        "density": 1310,
        "poissonsRatio": 0.4,
        "yieldStress": 97,
        "youngModulus": 3800,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "83od2xrhjYTi4yKMtvznm0uzzemRpwi8kGm7OHGhH8N",
        "name": "BASF-3DPS – TPU Ultrasint® TPU01",
        "density": 1100,
        "poissonsRatio": 0.35,
        "yieldStress": 30,
        "youngModulus": 85,
        "thermalExpansion": null,
        "thermalConductivity": null,
        "referenceTemperature": null,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "8zMm59v5M5NWqcNCmmHCBW7JyvIEr9RIitMPyG9MPFV",
        "name": "Cobalt (Co)",
        "density": 8800,
        "poissonsRatio": 0.32,
        "yieldStress": 225,
        "youngModulus": 211000,
        "thermalExpansion": 0.0000125,
        "thermalConductivity": 69.21,
        "referenceTemperature": 293,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Cobalt,
        "manufacturingMethod": ManufacturingMethod.Milling
    },
    {
        "id": "vlXm6QzKsP0Oq3hFrPmLW9EE6y73b7qZSykOsmdQjIp",
        "name": "Copper Alloy (UNS C94500)",
        "density": 9400,
        "poissonsRatio": 0.34,
        "yieldStress": 83,
        "youngModulus": 117000,
        "thermalExpansion": 0.0000185,
        "thermalConductivity": 52,
        "referenceTemperature": 293,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Copper,
        "manufacturingMethod": ManufacturingMethod.Milling
    },
    {
        "id": "kphsFkZGA80tLuhlrRnU4uC5umgga0eOJyNoyKPj1Z2",
        "name": "Henkel Loctite 3D IND405",
        "density": 1134,
        "poissonsRatio": 0.35,
        "yieldStress": 43,
        "youngModulus": 1500,
        "thermalExpansion": 0,
        "thermalConductivity": 0,
        "referenceTemperature": 0,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "27AAKpwty6HFqZ1bTt56jPjaOveP7n6mcPCEpCF7DYw",
        "name": "Henkel Loctite 3D IND147 Black",
        "density": 1260,
        "poissonsRatio": 0.35,
        "yieldStress": 67,
        "youngModulus": 3190,
        "thermalExpansion": 0,
        "thermalConductivity": 0,
        "referenceTemperature": 0,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "OWBfdjIHK1wWejKwiIiV0nbfiO6u6YZ6zP0roRf7Bsv",
        "name": "BASF-3DPS - Ultracur3D® RG35",
        "density": 1200,
        "poissonsRatio": 0.4,
        "yieldStress": 72.2,
        "youngModulus": 2611,
        "thermalExpansion": 0,
        "thermalConductivity": 0,
        "referenceTemperature": 0,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "0fGFsgbMubSyiWswu8mzTJQSoKZabQAJt0O4bsbaTjm",
        "name": "BASF-3DPS - Ultrasint® PP1400B",
        "density": 890,
        "poissonsRatio": 0.375,
        "yieldStress": 33.4,
        "youngModulus": 1204,
        "thermalExpansion": 0,
        "thermalConductivity": 0,
        "referenceTemperature": 0,
        "category": MaterialCategory.Polymer,
        "type": MaterialType.Polymer,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "VoY55hDsJo3SKh0HM98hGj57QJvwcZh3ZgqFD3RmzAo",
        "name": "QUARTZ",
        "density": 2201,
        "poissonsRatio": 0.164,
        "yieldStress": 140,
        "youngModulus": 72495.9,
        "thermalExpansion": 5.1e-7,
        "thermalConductivity": 1.38,
        "referenceTemperature": 293,
        "category": MaterialCategory.Ceramic,
        "type": MaterialType.Ceramic,
        "manufacturingMethod": ManufacturingMethod.Milling
    },
    {
        "id": "2joVMx7vOWVM3KMwy5lvPABJzbrCQD3pmbF3cm40C2Z",
        "name": "Aluminum Al7075 T6",
        "density": 2795,
        "poissonsRatio": 0.33,
        "yieldStress": 503.3,
        "youngModulus": 71705.4,
        "thermalExpansion": 160,
        "thermalConductivity": 0.000021,
        "referenceTemperature": 293,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Aluminum,
        "manufacturingMethod": ManufacturingMethod.Milling
    },
    {
        "id": "wbK9fOeAFWPTMdrXdU1J9XGW2WUUja6u4cu05NLhLCC",
        "name": "SSAB AM Engineering",
        "density": 7800,
        "poissonsRatio": 0.3,
        "yieldStress": 1140,
        "youngModulus": 200000,
        "thermalExpansion": 0.000013,
        "thermalConductivity": 30,
        "referenceTemperature": 293,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Steel,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "aiSTjmWYqL7rIteykOv71IUSMm4gD4HRPwoGv32AXyV",
        "name": "SSAB AM Tough",
        "density": 7800,
        "poissonsRatio": 0.3,
        "yieldStress": 950,
        "youngModulus": 235000,
        "thermalExpansion": 0,
        "thermalConductivity": 0,
        "referenceTemperature": 0,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Steel,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    },
    {
        "id": "oAnqFXUzuYokrNSQdSvtezOHSlhX8CB8g6ViS843SYD",
        "name": "SSAB AM TS2",
        "density": 7800,
        "poissonsRatio": 0.3,
        "yieldStress": 1210,
        "youngModulus": 200000,
        "thermalExpansion": 0.000013,
        "thermalConductivity": 24,
        "referenceTemperature": 293,
        "category": MaterialCategory.Metal,
        "type": MaterialType.Steel,
        "manufacturingMethod": ManufacturingMethod.AdditiveManufacturing
    }
].map(Material.fromJSON).sort((a, b) => a.name.localeCompare(b.name));


export const FilterMaterials = (category?: MaterialCategory | null, manufacturingMethod?: ManufacturingMethod | null, query?: string | null) => {
    if (!category && !manufacturingMethod && !query) return Materials;

    let results: Material[] = Materials;

    if (query) {
        results = results.filter(material => material.name.toLowerCase().includes(query.toLowerCase()));
    }
    if (category) {
        results = results.filter(material => material.category === category);
    }
    if (manufacturingMethod) {
        results = results.filter(material => material.manufacturingMethod === manufacturingMethod);
    }

    return results;
}